import { render } from "./DashboardEnergyValueContainer.vue?vue&type=template&id=2f63fcdd&scoped=true&ts=true"
import script from "./DashboardEnergyValueContainer.vue?vue&type=script&lang=ts"
export * from "./DashboardEnergyValueContainer.vue?vue&type=script&lang=ts"

import "./DashboardEnergyValueContainer.vue?vue&type=style&index=0&id=2f63fcdd&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f63fcdd"]])

export default __exports__